<div class="flex flex-col gap-2 min-h-[calc(100dvh-4rem)] max-w-7xl mx-auto">

  <section class="bg-white border border-slate-200 rounded-2xl shadow-sm">
    <div class="flex flex-row flex-wrap items-center justify-between px-4 py-2.5 bg-slate-50/50 border-b border-slate-100 gap-3">
      <div class="flex flex-row flex-wrap items-center gap-2 sm:gap-3">
        <div class="flex flex-col gap-1.5">
          <skeleton width="4.5rem" height="0.5rem"></skeleton>
          <skeleton width="6rem" height="1.25rem"></skeleton>
        </div>

        <div class="hidden sm:block h-7 w-px bg-slate-200 mx-1"></div>

        <div class="flex flex-wrap items-center gap-4 bg-white px-3 py-2 rounded-xl border border-slate-100 shadow-sm w-full sm:w-auto">
          <div class="flex flex-col gap-1.5">
            <skeleton width="3.5rem" height="0.45rem"></skeleton>
            <skeleton width="3rem" height="0.7rem"></skeleton>
          </div>
          <div class="flex flex-col gap-1.5">
            <skeleton width="3.5rem" height="0.45rem"></skeleton>
            <skeleton width="4rem" height="0.7rem"></skeleton>
          </div>
          <div class="flex flex-col gap-1.5">
            <skeleton width="3.5rem" height="0.45rem"></skeleton>
            <skeleton width="4rem" height="0.7rem"></skeleton>
          </div>
        </div>
      </div>

      <skeleton width="9rem" height="2.25rem" rounded="rounded-xl"></skeleton>
    </div>

    <div class="px-4 py-3">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:flex lg:flex-row lg:items-end gap-3">
        @for (item of rows; track item) {
        <div class="flex-1 flex flex-col gap-1.5">
          <skeleton width="4rem" height="0.6rem"></skeleton>
          <skeleton width="100%" height="2.5rem" rounded="rounded-xl"></skeleton>
        </div>
        }
      </div>
    </div>
  </section>

  <section class="flex-1 flex flex-col bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
    <div class="p-3 border-b border-slate-100 bg-white flex flex-col md:flex-row items-stretch md:items-center gap-3">
      <skeleton width="100%" height="3rem" rounded="rounded-2xl"></skeleton>
      <skeleton width="10rem" height="3rem" rounded="rounded-2xl"></skeleton>
    </div>

    <div class="flex-1 overflow-auto divide-y divide-slate-50">
      @for (item of rows; track item) {
      <div class="flex flex-col md:flex-row md:items-center gap-2 md:gap-3 px-4 py-3">
        <div class="flex-1 flex flex-col gap-1.5">
          <skeleton width="60%" height="0.85rem"></skeleton>
          <skeleton width="30%" height="0.6rem"></skeleton>
        </div>
        <skeleton width="100%" height="1.75rem" rounded="rounded-lg"></skeleton>
        <skeleton width="100%" height="1.75rem" rounded="rounded-lg"></skeleton>
        <skeleton width="100%" height="1.75rem" rounded="rounded-lg"></skeleton>
        <skeleton width="100%" height="1.75rem" rounded="rounded-lg"></skeleton>
      </div>
      }
    </div>
  </section>

  <section class="sticky bottom-0 z-20 bg-slate-900 rounded-2xl p-3 shadow-2xl shadow-slate-900/40 border border-white/5">
    <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
      <div class="flex items-center gap-4">
        <div class="flex flex-col gap-1.5">
          <skeleton width="3.5rem" height="0.55rem" rounded="rounded" background="bg-white/10"></skeleton>
          <skeleton width="4.5rem" height="1.5rem" rounded="rounded" background="bg-white/10"></skeleton>
        </div>
        <skeleton width="10rem" height="2.5rem" rounded="rounded-2xl" background="bg-white/10"></skeleton>
      </div>

      <div class="flex items-center gap-3">
        <skeleton width="6rem" height="2.5rem" rounded="rounded" background="bg-white/10"></skeleton>
        <skeleton width="9rem" height="3rem" rounded="rounded-xl" background="bg-white/10"></skeleton>
        <skeleton width="3rem" height="3rem" rounded="rounded-xl" background="bg-white/10"></skeleton>
      </div>
    </div>
  </section>

</div>
